// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SettingLayout_wrap__3IqB8"};